module.exports = __webpack_public_path__ + "media/images/headline-8b584752d53824a3e4a1e4268c846b43.png";